import { AxiosRequestConfig } from 'axios';
import { ITable } from '../../../../../ApiManager';
import { FilterArray } from '../../../../../functions/FilterArray';
import { IToPerform } from '../../../toPerform/entities/IToPerform';
import { ToPerformRepository } from '../../../toPerform/repositories/ToPerformRepository';
import { IAnimal } from '../../entities/IAnimal';
import { AnimalRepository } from '../../repositories/AnimalRepository';

type Arguments = {
  config?: AxiosRequestConfig;
  propriedade_id: string;
};

export class SearchAnimalUseCase {
  constructor(
    private animalRepository: AnimalRepository,
    private toPerformRepository: ToPerformRepository,
  ) {}

  public async execute({
    config,
    propriedade_id,
  }: Arguments): Promise<IAnimal[]> {
    const params = config?.params;

    const keyIgnoredCaseParams = new RegExp(params.key, 'i');
    const racaIgnoredCase = new RegExp(params.ra_a, 'i');
    const sexoIgnoredCase = new RegExp(params.sexo, 'i');
    const categoriaIgnoredCase = new RegExp(params.categoria, 'i');

    const animals = await this.animalRepository.findByPropriedadeId(
      propriedade_id,
    );

    //console.log(animals);
    const toPerformData = await this.toPerformRepository.findAllAnimals();

    const animaisToPerform: IAnimal[] = toPerformData.map(item => {
      return { id: item.id, ...item.data, estado: 'ativo', imagens: [] };
    });

    animals
      .filter(({ id }) => animaisToPerform.some(({ id: id2 }) => id2 === id))
      .forEach((item, _, arr) => animals.slice(arr.indexOf(item), 1));

    animals.push(...animaisToPerform);

    const firstFilters = {
      estado: (value: any) =>
        params.estado === 'inativo'
          ? value === 'abatido' || value === 'morto' || value === 'vendido'
          : value === params.estado,
      pertencente: (value: any) =>
        params.pertencentes === true
          ? value === true
          : params.pertencentes === false
          ? value === false
          : !value,

      ...(!Number(params.key) && {
        nome: (value: any) => keyIgnoredCaseParams.test(value),
      }),
      ...(Number(params.key) && {
        numero_de_identificacao: (value: string) =>
          Number(params.key) === Number(value),
      }),
    };

    const secondFilters = {
      sexo: (sexo: string) => sexoIgnoredCase.test(sexo),
      categoria: (categoria: string) => categoriaIgnoredCase.test(categoria),
      ra_a: (ra_a: string) => racaIgnoredCase.test(ra_a),
      safra: (value: any) => Number(value) === Number(params.safra),
      lote: (value: any) => value === params.lote,
    };

    const filteredByFirstFilters = FilterArray(animals, firstFilters);

    const filteredBySecondFilters = FilterArray(
      filteredByFirstFilters,
      secondFilters,
    );

    if (filteredByFirstFilters.length === 0) {
      const filteredByBotomFilter = FilterArray(animals, {
        bottom_eletronico: (value: string) => value == params.key,
      });

      return filteredByBotomFilter;
    }

    const result =
      params.raça ||
      params.categoria ||
      params.sexo ||
      params.lote ||
      params.safra
        ? filteredBySecondFilters
        : filteredByFirstFilters;

    return result;
  }
}
